import React from 'react';
import Instructor from "../../../assets/Images/Instructor.png"
import CTAButton from "../HomePage/Button";
import HighlightText from "../HomePage/HighlightText";
import { FaArrowRight } from "react-icons/fa";

function InstructorSection(props) {
    return (
        // inset-20 bg-indigo-500 shadow-[rgba(245,245,245,1)_25px_25px_0px_0px]
        <div className='mt-16 mb-32'>
            <div className='flex flex-row max-[450px]:flex-col gap-20 items-center'>
                <div className='w-[50%] max-[450px]:w-full'>
                    <img className='inset-20 bg-indigo-500 shadow-[rgba(245,245,245,1)_-20px_-20px_0px_0px]' src={Instructor} alt="InstructorImage" />
                </div>
                <div className='w-[50%] max-[450px]:w-[80%] flex flex-col gap-10'>
                    <div className='text-4xl font-semibold w-[50%]'>
                        Become an <HighlightText text={"instructor"}/>
                    </div>
                    <p className='font-medium text-[16px] w-[80%] text-richblack-300'>Instructors from around the world teach millions of students on StudyNotion. We provide the tools and skills to teach what you love.</p>
                    
                    <div className='w-fit'>
                        <CTAButton active={true} linkto={"/signup"}>
                            <div className='flex gap-x-2 items-center'>Start Searching Today 
                                <FaArrowRight/>
                            </div>
                        </CTAButton>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default InstructorSection;